import { useCallback } from 'react';
import { usePostAssetActivityNoteMutation } from '@customer/store/apis/assetsApi';
import { useParams } from 'react-router-dom';
import AddNotePanel from '../components/add-note-panel/AddNotePanel';

export function AddAssetNotePanel() {
  const { assetId } = useParams();

  const [postActivityNote] = usePostAssetActivityNoteMutation();

  const onSubmitInternal = useCallback(
    async (text: string): Promise<boolean> => {
      if (typeof assetId === 'undefined') return false;

      return await postActivityNote({ id: assetId, text }).then(response => {
        return response.error === undefined;
      });
    },
    [postActivityNote, assetId],
  );

  return (
    <AddNotePanel
      successTrans="PostGenericNoteSuccess"
      errorTrans="PostGenericNoteError"
      onSubmit={onSubmitInternal}
    />
  );
}

export default AddAssetNotePanel;
